import React from 'react';
import './Banner.css';

const Banner = () => (
    <div className="banner d-flex align-items-center">
        <p className="col-md-8 text-center mb-5">Click on an image to earn points, but be careful not to click the same image twice!</p> 
        
    </div>
);

export default Banner;